import "./Operations.module.css";
import Header from "@/reusable_sections/Header";
import QualityCompliance from "./sections/QualityCompliance";
import LogisticsShipping from "./sections/LogisticsShipping";
import GetAQuoteCta from "./sections/GetAQuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function OperationsPage() {
  return <div>
      <Header />
      <QualityCompliance />
      <LogisticsShipping />
      <GetAQuoteCta />
      <Footer />
    </div>;
}